import { OperativeContributionRequestInterface } from '../interfaces/contribution.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('OperativeContributionRequest')
export class OperativeContributionRequest
  implements OperativeContributionRequestInterface
{
  @JsonProperty('Amount', Number, true)
  amount: number = undefined;

  @JsonProperty('Currency', String, true)
  currency: string = undefined;

  @JsonProperty('SmsValidation', Boolean, true)
  smsValidation: boolean = undefined;

  @JsonProperty('IBAN', String, true)
  iban: string = undefined;

  @JsonProperty('BankName', String, true)
  bankName: string = undefined;

  @JsonProperty('Type', String, true)
  type: string = undefined;

  @JsonProperty('FundLocation', String, true)
  fundLocation: string = undefined;

  @JsonProperty('ClientName', String, true)
  clientName: string = undefined;

  @JsonProperty('Email', String, true)
  email: string = undefined;

  @JsonProperty('Telephone', String, true)
  telephone: string = undefined;

  @JsonProperty('fundTransfers', [String], true)
  fundTransfers: string[] = undefined;

  @JsonProperty('activityId', String, true)
  activityId: string = undefined;

  @JsonProperty('VerificationId', String, true)
  verificationId: string = undefined;
}
